import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { paginationStyles } from './styles'
import { ChevronIcon } from '../icons'

const ScrollerControls = ({
  totalPages,
  currentPage,
  callback,
  hasTitle,
  buttonHeight,
  specialEvent,
  programmeTab,
  liveTab,
  recommendedTab,
}) => {
  const [buttonClicked, setButtonClicked] = useState(false)
  const arr = Array.from({ length: totalPages }, (_, n) => n + 1)
  return (
    <div className={['scroller-controls', specialEvent && 'special-event'].join(' ')}>
      { (!programmeTab && !liveTab) && !recommendedTab && (
        <ul className={[hasTitle ? 'has-title' : '', specialEvent ? 'special-event' : ''].join(' ')}>
          { arr.map(i => (
            <li key={i}>
              <button
                type="button"
                onClick={() => {
                  callback(i)
                  setButtonClicked(true)
                }}
                className={[
                  currentPage === i ? 'active' : '',
                  'pagination-button',
                  specialEvent ? 'special-event' : '',
                ].join(' ')}
              >
                Page {i}
              </button>
            </li>
          ))}
        </ul>
      )}
      <button
        disabled={!buttonClicked}
        className="pagination-nav prev"
        type="button"
        onClick={() => callback(currentPage - 1)}
        style={{ height: buttonHeight }}
      >
        <span className="button-text">Previous</span>
        <div className="icon-wrapper">
          <ChevronIcon direction="left" color="#fff" width="18" height="16" />
        </div>
      </button>
      <button
        className="pagination-nav next"
        type="button"
        onClick={() => {
          callback(currentPage + 1)
          setButtonClicked(true)
        }}
        style={{ height: buttonHeight }}
      >
        <span className="button-text">Next</span>
        <div className="icon-wrapper">
          <ChevronIcon direction="right" color="#fff" width="18" height="16" />
        </div>
      </button>
      <style jsx>{paginationStyles}</style>
    </div>
  )
}

ScrollerControls.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
  hasTitle: PropTypes.bool,
  buttonHeight: PropTypes.string,
  specialEvent: PropTypes.bool,
  programmeTab: PropTypes.bool,
  liveTab: PropTypes.bool,
  recommendedTab: PropTypes.bool,
}

ScrollerControls.defaultProps = {
  hasTitle: true,
  buttonHeight: null,
  specialEvent: false,
  programmeTab: false,
  liveTab: false,
  recommendedTab: false,
}

export default ScrollerControls
